<fpc-input-field-label [label]="_label" [required]="required" [popoverText]="_popoverText">
  <div class="form-check form-check-inline" *ngFor="let opt of options">
    <input class="form-check-input" type="radio" [id]="id" [formControl]="control" [placeholder]="placeholder" name="{{name}}" value="{{opt.value}}"
      [required]="required">
    <label class="form-check-label h5 mb-0 fw-bold" [attr.for]="opt.value">{{opt.value}}</label>
  </div>
</fpc-input-field-label>